import { handle } from "../utils/handler.js";
var server_default = {
  fetch: handle
};
export {
  server_default as default
};
